module.exports = __webpack_public_path__ + "img/home_business_eng.8666b050.png";